// Dev user switcher has been moved into TopBar.jsx (left of the gear icon).
// This file is kept as a no-op so existing imports in AppShell/PortalShell don't break.
export default function DevUserSwitcher() {
  return null;
}
